import { createSelector, createSelectorFactory, defaultMemoize } from '@ngrx/store';

import { UserSelectors } from '@recruitee/account-data';
import { ShortInterviewResultRequest } from '@recruitee/http-types';
import { InterviewTemplateSelectors } from '@recruitee/interview-templates-data';
import { createEntityCollectionStore, memoizeSelector } from '@recruitee/ngrx';

const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<ShortInterviewResultRequest>()(
    'InterviewScheduleResultRequestsCollection',
    {
      references: makeRef => [
        makeRef('adminId', 'admin', id => createSelector(UserSelectors.byId(id!), state => state!)),
        makeRef('interviewTemplateId', 'interviewTemplate', id =>
          createSelector(InterviewTemplateSelectors.byId(id!), state => state!),
        ),
      ],
      customActions: adapter => ({
        references: (state, payload: ShortInterviewResultRequest[]) =>
          adapter.updateOrCreateMany(state, payload),
      }),
    },
  );

const InterviewScheduleResultRequestsCollectionSelectors = {
  ...selectors,
  byIds: memoizeSelector((interviewScheduleResultRequestsIds: number[]) =>
    createSelectorFactory(defaultMemoize)(
      ...interviewScheduleResultRequestsIds.map(interviewScheduleResultRequestsIds =>
        selectors.byIdWithReferences(interviewScheduleResultRequestsIds),
      ),
      (...result: ShortInterviewResultRequest[]) => result,
    ),
  ),
};

export {
  actions as InterviewScheduleResultRequestsCollectionActions,
  InterviewScheduleResultRequestsCollectionSelectors,
  reducer as InterviewScheduleResultRequestsCollectionReducer,
  namespace as InterviewScheduleResultRequestsCollectionNamespace,
};
